import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangePassengerNameCommand extends BaseCommand {
  CommandName = "ChangePassengerName";
  Command: {
    Value: string;
    BookingItemTmpId: string;
  };
  constructor(sessionId: string, operationId: string, bookingItemTmpId: string, value: string) {
    super(sessionId, operationId);
    this.Command = { BookingItemTmpId: bookingItemTmpId, Value: value };
  }
}
